import { FunctionComponent, Fragment } from 'preact';
import styles from './styles.module.scss';

interface Props {
  command: chrome.commands.Command,
}

export const getShortcutList = (shortcut = ''): string[] => {
  try {
    const separator = shortcut.includes('+') ? '+' : '';
    return shortcut.split(separator)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((key) => key === '⌘' ? `Cmd ⌘` : key)
  } catch (err) {
    console.error('getShortcutList', err);
    return null;
  }
}

const Shortcut: FunctionComponent<Props> = ({ command }: Props) => {
  const list = getShortcutList(command.shortcut);

  return list ? (
    <div className={styles.shortcut}>
      Try

      {list.map((key, i) => (
        <Fragment key={i}>
          {!!i && '+'}
          <span className={styles.key}>{key}</span>
        </Fragment>
      ))}
    </div>
  ) : null;
}

export default Shortcut;
